export interface ParsedEmail {
  username: string
  domain: string
}

/**
 * Parses an email address into username and domain parts
 * @param email - The email address to parse
 * @returns Object containing username and domain parts
 */
export const parseEmail = (email: string): ParsedEmail => {
  const parts = email.split('@')
  return {
    username: parts[0] || '',
    domain: parts.length > 1 ? parts[1] : '',
  }
}
